/**
 * @generated SignedSource<<93d10b39e8ad880b6982a386f3f6f84c>>
 * @relayHash 252c4a38e19597b70bb83f61f55316c6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 3fc9391556e041fc31a33d71fe889010c2f35c42d9f37c56b22d3c601366b0be

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { ui_jiraCalendarQuery } from './ui_jiraCalendarQuery.graphql';

const node: PreloadableConcreteRequest<ui_jiraCalendarQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "3fc9391556e041fc31a33d71fe889010c2f35c42d9f37c56b22d3c601366b0be",
    "metadata": {},
    "name": "ui_jiraCalendarQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
